import { React, useRef } from "react";
import { useSliderState } from "react-stately";

import {
  mergeProps,
  useFocusRing,
  useNumberFormatter,
  useSlider,
  useSliderThumb,
  VisuallyHidden,
} from "react-aria";

export function RangeSlider(props) {
  let trackRef = useRef(null);

  let numberFormatter = useNumberFormatter(props.formatOptions);
  let state = useSliderState({ ...props, numberFormatter });
  let { groupProps, trackProps, labelProps, outputProps } = useSlider(
    props,
    state,
    trackRef
  );

  let thumbDisplayConfig = {
    minValue: props.minValue,
    maxValue: props.maxValue,
    step: props.step,
    extraContent_1: props.extraThumbContent[0],
    extraContent_2: props.extraThumbContent[1]
  }


  return (
    <div {...groupProps} className={`slider ${state.orientation}`}>
      <div
        {...trackProps}
        ref={trackRef}
        className={`track ${state.isDisabled ? "disabled" : ""}`}
      >
        <Thumb
          index={0}
          state={state}
          trackRef={trackRef}
          currentValue={state.getThumbValueLabel(0)}
          thumbDisplayConfig={thumbDisplayConfig}
        />
        <Thumb
          index={1}
          state={state}
          trackRef={trackRef}
          currentValue={state.getThumbValueLabel(1)}
          thumbDisplayConfig={thumbDisplayConfig}
        />
      </div>
    </div>
  );
}

function Thumb(props) {
  let { state, trackRef, index, currentValue, thumbDisplayConfig } = props;
  let inputRef = useRef(null);
  let { thumbProps, inputProps, isDragging } = useSliderThumb(
    {
      index,
      trackRef,
      inputRef,
    },
    state
  );

  let {minValue, maxValue, step, extraContent_1, extraContent_2 } = thumbDisplayConfig;

  let format_currentValue = currentValue;
  if (currentValue.includes(",")){
    format_currentValue = parseInt(currentValue.replace(",", ""));
  }

  let { focusProps, isFocusVisible } = useFocusRing();
  return (
    <div
      {...thumbProps}
      className={`thumb ${isFocusVisible ? "focus" : ""} ${
        isDragging ? "dragging" : ""
      }`}
    >
      <div className="thumb_display">
        {format_currentValue <= maxValue - step
          ? format_currentValue + extraContent_1
          : extraContent_2}
      </div>
      <VisuallyHidden>
        <input ref={inputRef} {...mergeProps(inputProps, focusProps)} />
      </VisuallyHidden>
    </div>
  );
}
